
import { Vue, Component, Prop, Watch, Ref } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import lazyInject from '@/di';
import OrderService from '@/services/order.service';
import { DebounceTime } from '@/common/decorator';
import CarService from '@/services/car.service';

@Component({})
export default class CarGiveOrderDuration extends Vue {
  @Prop()
  giveOrderVisible!: boolean;

  @Ref()
  ruleForm!: FormModel;


  @lazyInject(CarService)
  carService!: CarService;

  @Prop()
  cacheNo!: string;

  @lazyInject(OrderService)
  orderService!: OrderService;

  visible = false;

  disabled = false;

  form = {
    value: '',
  };

  rules = {
    value: [
      { required: true, message: '请输入赠送天数', trigger: 'blur' },
      {
        validator: (
          rule: { [key: string]: string | (() => boolean) },
          value: string,
        ) => {
          return !isNaN(+value);
        },
        message: '请输入数字',
        trigger: 'blur',
      },
    ],
  };

  layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 14 },
  };

  @Watch('giveOrderVisible')
  giveOrderVisibleChange() {
    this.visible = this.giveOrderVisible;
  }

  cancel() {
    this.ruleForm.resetFields();
    this.$emit('close');
  }

  @DebounceTime(1000)
  submitForm() {
    this.ruleForm.validate(async (valid) => {
      if (valid) {
        this.disabled = true;
        const data = {
          order_no: this.cacheNo,
          days: +this.form.value,
        };
        const res = await this.carService.postShopOrderDonate(data);
        this.disabled = false;
        if (!res) return;
        this.$message.success(res);
        this.ruleForm.resetFields();
        this.$emit('close');
      }
    });
  }
}
